import { Contact } from './Contact';

export class Column {
  _id = '';
  _name = '';
  _description = '';
  _items = [];
  _bdID = '';
  _followUpMessage = {};

  constructor(name, description, items = [], bdID = '', followUpMessage = {}) {
    this._id = name;
    this._name = name;
    this._description = description;
    this._followUpMessage = followUpMessage;
    this._items = items;
    this._bdID = bdID;
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get description() {
    return this._description;
  }

  get items() {
    return this._items;
  }

  get bdID() {
    return this._bdID;
  }

  get followUpMessage() {
    return this._followUpMessage;
  }

  set id(id) {
    this._id = id;
  }

  set name(name) {
    this._name = name;
  }

  set description(description) {
    this._description = description;
  }

  set items(items) {
    this._items = items;
  }

  set followUpMessage(followUpMessage) {
    this._followUpMessage = followUpMessage;
  }

  static fromJson(json) {
    const items = json.items.map((item) => Contact.fromJson(item));
    return new Column(
      json.name,
      json.description,
      items,
      json._id,
      json.followUpMessage,
    );
  }

  toJson() {
    return {
      name: this._name,
      description: this._description,
      items: this._items.map((item) => item.toJson()),
      _id: this._id,
      followUpMessage: this._followUpMessage,
    };
  }

  clone() {
    return new Column(
      this._name,
      this._description,
      this._items.map((item) => item.clone()),
      this._bdID,
      this._followUpMessage,
    );
  }
}
